
import './App.css';
import React, {useRef, useEffect, use} from 'react';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from "@vercel/analytics/react";

import Navbar from './Navbar';
import Intro from './Intro';
import Education from './Education';
import Experience from './Experience';
import Skills from './Skills';
import Contact from './Contact';
import AdsenseComponent from './AdsenseComponent';

function App() {
  const educationRef = useRef(null);
  const experienceRef = useRef(null);
  const skillsRef = useRef(null);
  const contactRef = useRef(null);
  const introRef = useRef(null);
  const adsenseRef = useRef(null);

  ReactGA.initialize('G-MDETVHE7QS');
  ReactGA.pageview(window.location.pathname + window.location.search);

  // useEffect(() => {
  //     const tagManagerArgs = {
  //         gtmId: 'G-MDETVHE7QS'
  //     };
  //     TagManager.initialize(tagManagerArgs);
  // }, []);

  return (
    <div className="App  mr-auto ml-auto ">
      <Analytics />
      
      <Navbar educationRef={educationRef} experienceRef={experienceRef} skillsRef={skillsRef} contactRef={contactRef} introRef={introRef}/>
      <Intro introRef={introRef}/>
      <Education educationRef={educationRef} />
      <Experience experienceRef={experienceRef} />
      <Skills skillsRef={skillsRef}/>
      <Contact contactRef={contactRef} />

      <AdsenseComponent />
      <SpeedInsights />
      
      
    </div>
  );
}

export default App;
